module.exports = __webpack_public_path__ + "img/esmeralda-resort.6d052015.jpg";